import * as React from 'react';

import {NumberedList} from 'shells/bulleted-list/numbered-list';
import {HelpModal} from 'shells/modal/help-modal';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {ModalBody} from 'shells/typography/modal-body';
import {ModalHeader} from 'shells/typography/modal-header';

import {UnsubscribeModalGraphic} from './assets/unsubscribe-modal-graphic';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function UnsubscribeModal(props: Props) {
    return (
        <HelpModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            artImage={<UnsubscribeModalGraphic />}
            bodyComponent={
                <div className='pad-16'>
                    <ModalHeader>Add an unsubscribe link</ModalHeader>
                    <SpacerGroup mb={32}>
                        <ModalBody>
                            You can add an <b>unsubscribe link</b> to existing words and phrases or
                            insert it directly into a text box.
                        </ModalBody>
                    </SpacerGroup>
                    <NumberedList
                        size='normal'
                        items={[
                            <ModalBody key='1'>
                                Highlight some text or place your cursor anywhere in the message
                            </ModalBody>,
                            <ModalBody key='2'>
                                Click the “Special links” dropdown in the text toolbar and hover
                                over “Required links”
                            </ModalBody>,
                            <ModalBody key='3'>
                                Select “Unsubscribe link” to add it to your message
                            </ModalBody>,
                        ]}
                    />
                </div>
            }
        />
    );
}
